(function() {
    'use strict';

    angular.module('aprima-core-ui').factory('GeneralNotesModal', [
        '$uibModal',
        GeneralNotesModal
    ]);

    angular.module('aprima-core-ui').controller('GeneralNotesModalCtrl', [
        '_',
        '$q',
        '$uibModalInstance',
        '$window',
        'currentNote',
        'debounce',
        'DeviceSettings',
        'disableFormatting',
        'GeneralNotesRepository',
        'generalNoteTypeId',
        'generalNoteTypeKey',
        'gettext',
        'ListService',
        'maxCharacters',
        'ServerInfoRepository',
        'title',
        'toaster',
        'uxConstants',
        GeneralNotesModalCtrl,
    ]);

    function GeneralNotesModal(
        $modal
    ) {
        return {
            openModal: openModal,
            openModalOnly: openModalOnly,
        };

        function openModal(title, currentNote, disableFormatting, maxCharacters, generalNoteTypeKey, generalNoteTypeId) {
            return openModalOnly(title, currentNote, disableFormatting, maxCharacters, generalNoteTypeKey, generalNoteTypeId).result;
        }

        function openModalOnly(title, currentNote, disableFormatting, maxCharacters, generalNoteTypeKey, generalNoteTypeId) {
            var modalInstance = $modal.open({
                templateUrl: '/core-ui/modal-views/generalNotesModal.html',
                windowClass: 'modal-full',
                controller: 'GeneralNotesModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    currentNote: function() { return currentNote; },
                    generalNoteTypeKey: function() {return generalNoteTypeKey;},
                    generalNoteTypeId: function() {return generalNoteTypeId;},
                    disableFormatting: function() {return disableFormatting;},
                    maxCharacters: function() {return maxCharacters;},
                    title: function() {return title;},
                },
            });

            return modalInstance;
        }
    }

    function GeneralNotesModalCtrl(
        _,
        $q,
        $modalInstance,
        $window,
        currentNote,
        debounce,
        DeviceSettings,
        disableFormatting,
        GeneralNotesRepository,
        generalNoteTypeId,
        generalNoteTypeKey,
        gettext,
        ListService,
        maxCharacters,
        ServerInfoRepository,
        title,
        toaster,
        uxConstants
    ) {
        var vm = this;

        vm.generalNotesSupported = ServerInfoRepository.isFeatureSupported('GeneralNotes');
        vm.currentNote = currentNote || '';
        vm.disableFormatting = !!disableFormatting;
        vm.title = title || 'General Notes';
        vm.maxCharacters = maxCharacters;
        vm.searchText = '';
        vm.tinymceHeight = $window.innerHeight-240; //modal padding, header footer height, right section padding
        vm.includeInactive = false;
        vm.searchGeneralNoteType = null;
        var originalGeneralNoteType = null;
        vm.generalNoteTypeList = [];
        vm.loadingSearch = false;
        vm.initialLoading = false;

        vm.cancel = cancel;
        vm.ok = ok;
        vm.getRemainingCharacters = getRemainingCharacters;
        vm.shouldSwapButtons = shouldSwapButtons;

        if(!vm.generalNotesSupported) {
            return;
        }

        // use result.finally in case the modal gets closed from outside of this controller
        $modalInstance.result.finally(function() {
            if(generalNoteTypeKey && vm.searchGeneralNoteType && (!originalGeneralNoteType || originalGeneralNoteType.Id !== vm.searchGeneralNoteType.Id)) {
                var savePromise = GeneralNotesRepository.saveGeneralNoteTypeSetting(generalNoteTypeKey, vm.searchGeneralNoteType);
                return savePromise;
            }
        });

        vm.changeSearchCriteria = debounce(uxConstants.searchDebounceTime, searchGeneralNotes);
        vm.appendNote = appendNote;

        onLoad();
        
        function onLoad(){
            vm.initialLoading = true;
            var promises = [];
            if(generalNoteTypeKey && !generalNoteTypeId) {
                promises.push(GeneralNotesRepository.getGeneralNoteType(generalNoteTypeKey).then(function(data) {
                    vm.searchGeneralNoteType = data && data.plain ? data.plain() : data;
                    if (vm.searchGeneralNoteType){
                        originalGeneralNoteType = vm.searchGeneralNoteType;
                        searchGeneralNotes();
                    }
                }));
            }

            promises.push(ListService.getList('generalnotetypes').then(function(result) {
                vm.generalNoteTypeList = result;

                if(!vm.searchGeneralNoteType && generalNoteTypeId) {
                    vm.searchGeneralNoteType = _.find(vm.generalNoteTypeList, {Id: generalNoteTypeId});
                    if (vm.searchGeneralNoteType){
                        originalGeneralNoteType = vm.searchGeneralNoteType;
                        searchGeneralNotes();
                    }
                }
            }));
            
            $q.all(promises).finally(function() {
                vm.initialLoading = false;
            });
        }

        function appendNote(entry) {
            if (!!vm.maxCharacters && (vm.maxCharacters < (vm.currentNote.length + entry.Notes.length))) {
                toaster.pop({
                    type: 'error',
                    title: gettext('Cannot Insert'),
                    body: gettext('The note you are inserting would exceed the maximum number of characters allowed.')
                });
                return;
            }

            vm.currentNote = vm.currentNote + entry.Notes;
        }

        function searchGeneralNotes() {
            vm.loadingSearch = true;
            var generalNoteTypeId = vm.searchGeneralNoteType && vm.searchGeneralNoteType.Id;
            GeneralNotesRepository.search(vm.searchText, generalNoteTypeId, vm.includeInactive)
                .then(function(data){
                    vm.generalNoteList = data && data.plain();
                })
                .finally(function(){
                    vm.loadingSearch = false;
                });
        }

        function getRemainingCharacters() {
            var maxLength = vm.maxCharacters;

            if (vm.currentNote) {
                maxLength -= vm.currentNote.length;
            }

            return maxLength;
        }

        function cancel() {
            $modalInstance.dismiss();
        }
        
        function ok() {
            $modalInstance.close(vm.currentNote);
        }

        function shouldSwapButtons() {
            return DeviceSettings.isPrm;
        }
    }
})();